import React from 'react';
import { domainUrl } from './urls';
import { AiOutlineLink } from 'react-icons/ai';
import { Dropdown } from 'react-bootstrap';

const CopyBtn = ({ id, name, setIsShowModal }) => {
  const handleCopy = (e) => {
    var value = domainUrl + 'article/public/' + id;
    value = value + '\n' + name;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(value).then(() => setIsShowModal(true));
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = value;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setIsShowModal(true);
    }
  };
  return (
    <Dropdown.Item
      href="#"
      onClick={() => handleCopy(id)}
      className="text-green-1"
    >
      <AiOutlineLink className="margin-right" />
      Copy
    </Dropdown.Item>
  );
};

export default CopyBtn;
